import { Table } from "@mui/joy";
import { CsvData } from "../../types";
import { Dispatch, SetStateAction } from "react";
import { PaginationButtons } from "../UtilitiesComponents/PaginationButtons";
import { LoadingComponent } from "../UtilitiesComponents/LoadingComponent";
import { ElementsNotFound } from "../UtilitiesComponents/ElementsNotFound";

interface Props {
    listCitas: Array<CsvData>;
    nextPage: boolean;
    setPageNumber: Dispatch<SetStateAction<number>>;
    pageNumber: number;
    dataLoading: boolean;
}

export function ConsultaRespuestas({ listCitas, nextPage, setPageNumber, pageNumber, dataLoading }: Props) {
    return (
        <div>

        <div className="overflow-auto max-h-[600px] rounded-lg border border-slate-200 my-4">
            <Table 
                stickyHeader
                sx={(theme) => ({
                    "th": { bgcolor: "#111827", color: "#fff", textAlign: "center" },
                    "td": { textAlign: "center" }
                })}>
                <thead className="bg-slate-800 text-white rounded-md py-2 font-medium">
                    <tr >
                        <th className="w-28">Sucursal</th>
                        <th className="w-28">Fecha</th>
                        <th className="w-28">Hora</th>
                        <th className="w-28">Doctor</th>
                        <th className="w-28">Cliente</th>
                        <th className="w-28">Motivo</th>
                        <th className="w-28">Telefono</th>
                        <th className="w-28">Confirmacion de la Cita</th>
                        <th className="w-28">Status de la Cita</th>
                        <th className="w-28">Fecha de Respuesta</th>
                        <th className="w-28">Respuesta</th>
                        <th className="w-28">Canal</th>
                    </tr>
                </thead>
                {!dataLoading && (
                <tbody>
                {listCitas.map((value, index) => (
                    <tr key={index} className={`hover:bg-slate-100`}>
                        <td>{value.sucursal}</td>
                        <td>{value.fecha}</td>
                        <td>{value.hora}</td>
                        <td>{value.doctor}</td>
                        <td>{value.cliente}</td>
                        <td>{value.motivo}</td>
                        <td>{value.telefono}</td>
                        <td>{value.confirmacion}</td>
                        <td>{value.status}</td>
                        <td>{value.fechaRespuesta}</td>
                        <td className="text-center"><p>{value.respuesta}</p></td>
                        <td>{value.canal}</td>
                    </tr>
                ))}
                </tbody>
                )}
            </Table>

            {dataLoading && (
                <div className="grid justify-items-center w-full h-[600px]">
                    <LoadingComponent />
                </div>

            )}

            {listCitas.length == 0 && (
                <ElementsNotFound />
            )}

        </div>

        <div className="flex justify-center">
            <PaginationButtons
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                nextPage={nextPage}/>
        </div>

        </div>
    );
}